import login from '../../Actions/login';
import { getCopy } from '../../helpers';
const { types } = login;

const initialState = {
    login: {},
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.AUTHENTICATE:
            return {
                ...state,
                login: getLoginData(action.data)
            };
        case types.UPDATE_LOGIN_STATUS:
            return {
                ...state,
                isLogged: action.data.isLogged
            };        
        default:
            return state;
    }
}

const getLoginData = data => {
    let copy = getCopy(data);
    delete copy.values.password;
    return copy;
}

export default loginReducer;